import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a713023"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "df"
};
const _hoisted_2 = {
  class: "df-table"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_8 = {
  class: "seasonal"
};
const _hoisted_9 = {
  key: 0,
  class: "box"
};
const _hoisted_10 = {
  class: "title"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_14 = {
  class: "coverage"
};
const _hoisted_15 = {
  class: "box"
};
const _hoisted_16 = {
  class: "title purple"
};
const _hoisted_17 = {
  class: "coverage-container"
};
const _hoisted_18 = {
  class: "coverage-box"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-text"
}, "First comers", -1));
const _hoisted_20 = {
  class: "coverage-sub"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-line"
}, null, -1));
const _hoisted_22 = {
  class: "coverage-box"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "coverage-text"
}, "Slow movers", -1));
const _hoisted_24 = {
  class: "coverage-sub"
};
const _hoisted_25 = {
  class: "coverage-sub"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1));
const _hoisted_28 = {
  class: "standard",
  width: "40"
};
const _hoisted_29 = {
  class: "th"
};
const _hoisted_30 = {
  class: "standard"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Product name", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  width: "78"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Orderable")])], -1));
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  width: "156"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th end"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Avg 30D velocity")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cells"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "90D")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "30D")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "14D")]), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-cell"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "7D")])])], -1));
const _hoisted_34 = {
  class: "standard pastel-yellow",
  width: "94"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title dark"
}, "Weighted 30D velocity", -1));
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard blue",
  width: "76"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title blue"
}, "Additional boost")])], -1));
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard purple",
  width: "80"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "30D sales forecast")])], -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard white",
  width: "88"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title dark"
}, "Available inventory")])], -1));
const _hoisted_39 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  width: "80"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "th center"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Days left")])], -1));
const _hoisted_40 = {
  class: "standard coverage-bottom",
  width: "140"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title purple"
}, "Raw quantity to send", -1));
const _hoisted_42 = {
  class: "standard purple-dark",
  width: "110"
};
const _hoisted_43 = {
  class: "th"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "standard",
  width: "32"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_app_checkbox = _resolveComponent("app-checkbox");
  const _component_demand_forecasting_row = _resolveComponent("demand-forecasting-row");
  const _component_loading_table = _resolveComponent("loading-table");
  const _component_app_modal = _resolveComponent("app-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_loading_table, {
    loading: !$options.settingsInitialized
  }, {
    default: _withCtx(() => [_createElementVNode("table", _hoisted_2, [_createElementVNode("thead", {
      class: "sticky standard",
      style: _normalizeStyle($options.stickyPosition)
    }, [_createElementVNode("tr", null, [_hoisted_3, _hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7, _createElementVNode("th", _hoisted_8, [$options.additionalBoostType && $props.settings.boost_active ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString($options.additionalBoostType), 1)])) : _createCommentVNode("", true)]), _hoisted_11, _hoisted_12, _hoisted_13, _createElementVNode("th", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, "Coverage → " + _toDisplayString($options.totalCoverage) + "D", 1), _createVNode(_component_app_icon, {
      icon: "info-circle",
      size: 14,
      color: "#423994",
      id: "coverege-days"
    }), _createVNode(_component_app_popover, {
      target: "coverege-days",
      "auto-width": "",
      placement: "bottom"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("div", _hoisted_20, [_createTextVNode(" Total coverage: "), _createElementVNode("span", null, _toDisplayString($options.totalCoverage) + " days", 1)])]), _hoisted_21, _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createTextVNode(" Velocity threshold: "), _createElementVNode("span", null, _toDisplayString($props.settings.velocity_threshold) + "U/30D", 1)]), _createElementVNode("div", _hoisted_25, [_createTextVNode(" Target inventory: "), _createElementVNode("span", null, _toDisplayString($props.settings.target_inventory) + "U", 1)])])])]),
      _: 1
    })])]), _hoisted_26, _hoisted_27]), _createElementVNode("tr", null, [_createElementVNode("th", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createVNode(_component_app_checkbox, {
      modelValue: $data.toggleAll,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.toggleAll = $event),
      onChange: $options.onToggleAll
    }, null, 8, ["modelValue", "onChange"])])]), _createElementVNode("th", _hoisted_30, [_createElementVNode("div", {
      class: "th sortable",
      onClick: _cache[1] || (_cache[1] = _withModifiers($event => $options.onSort('product_name'), ["stop"]))
    }, [_hoisted_31, _createVNode(_component_app_icon, {
      icon: `chevron-down2`,
      color: $props.sortField == 'product_name' ? '#5A52AE' : '#757575',
      style: _normalizeStyle(`transform: rotate(${$props.sortDirection == 'asc' ? 0 : 180}deg)`)
    }, null, 8, ["color", "style"])])]), _hoisted_32, _hoisted_33, _createElementVNode("th", _hoisted_34, [_createElementVNode("div", {
      class: "th sortable",
      onClick: _cache[2] || (_cache[2] = _withModifiers($event => $options.onSort('weighted_30d_velocity'), ["stop"]))
    }, [_hoisted_35, _createVNode(_component_app_icon, {
      icon: `chevron-down2`,
      color: $props.sortField == 'weighted_30d_velocity' ? '#5A52AE' : '#757575',
      style: _normalizeStyle(`transform: rotate(${$props.sortDirection == 'asc' ? 0 : 180}deg)`)
    }, null, 8, ["color", "style"])])]), _hoisted_36, _hoisted_37, _hoisted_38, _hoisted_39, _createElementVNode("th", _hoisted_40, [_createElementVNode("div", {
      class: "th sortable",
      onClick: _cache[3] || (_cache[3] = _withModifiers($event => $options.onSort('raw_quantity_to_send'), ["stop"]))
    }, [_hoisted_41, _createVNode(_component_app_icon, {
      icon: `chevron-down2`,
      color: $props.sortField == 'raw_quantity_to_send' ? '#5A52AE' : '#757575',
      style: _normalizeStyle(`transform: rotate(${$props.sortDirection == 'asc' ? 0 : 180}deg)`)
    }, null, 8, ["color", "style"])])]), _createElementVNode("th", _hoisted_42, [_ctx.df_manual_override_active ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "manual-close",
      onClick: _cache[4] || (_cache[4] = _withModifiers($event => $data.confirmClearOverrideModal = true, ["stop"]))
    }, [_createVNode(_component_app_icon, {
      icon: "cross",
      size: 16,
      color: "#134890"
    })])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", {
      class: _normalizeClass(["title dark-blue", {
        'title-loader': $props.manualOverrideTaskRunning
      }])
    }, [$props.manualOverrideTaskRunning ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "upload-processing-icon-new",
      size: 20
    })) : (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createTextVNode(" Manual Override ")], 64))], 2)])]), _hoisted_44])], 4), _createElementVNode("tbody", null, [$options.settingsInitialized ? (_openBlock(true), _createElementBlock(_Fragment, {
      key: 0
    }, _renderList($props.items, (item, index) => {
      return _openBlock(), _createBlock(_component_demand_forecasting_row, {
        key: `${item.asin}-${index}`,
        item: item,
        manualOverrideTaskRunning: $props.manualOverrideTaskRunning,
        selected: $props.selected.includes(item.sku),
        settings: $props.settings,
        onSelect: $options.onSelect,
        onOrderable: $options.onOrderable,
        onOrderableUnits: $options.onOrderableUnits
      }, null, 8, ["item", "manualOverrideTaskRunning", "selected", "settings", "onSelect", "onOrderable", "onOrderableUnits"]);
    }), 128)) : _createCommentVNode("", true)])])]),
    _: 1
  }, 8, ["loading"]), _createVNode(_component_app_modal, {
    modelValue: $data.confirmClearOverrideModal,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.confirmClearOverrideModal = $event),
    title: "Manual Override",
    "cancel-title": "Cancel",
    "ok-title": "Confirm",
    no_close_on_outside_click: true,
    onOk: $options.onClearAllOverride
  }, {
    default: _withCtx(() => [_createTextVNode(" Are you sure you want to clear all overrides? ")]),
    _: 1
  }, 8, ["modelValue", "onOk"])]);
}